import * as _ from 'lodash';
import {createSelector} from 'reselect';
import {getUnusedProductVariations} from '../../../MyAccount/Inventory/EditProductSelectors';

export const hasVariationsToAddDialogStoreProps = createSelector(
  [getUnusedProductVariations],
  variationsSpecificSetForAddDialog => {
    return {hasVariationsToAdd: !_.isEmpty(variationsSpecificSetForAddDialog)};
  }
);
